import * as deviceActions from "src/modules/device/duck/actions";
import Messenger from "../lib/Messenger";
import AppStatus from "src/constants/AppStatus";
import { appFailure, presenceUpdated, connectionLost } from "src/duck/actions";
import { getStatus } from "src/duck/selectors";
import { getFamilyName } from "src/modules/auth/duck/selectors";
import debug from "src/modules/debug-logger";

const log = window.require("electron-log");

export default function initializeMessenger(dispatch, getState) {
  const messenger = new Messenger();

  messenger.on("xmpp-status", async (xmppStatus) => {
    const state = getState();
    const status = getStatus(state);

    if (xmppStatus !== "online" && status === AppStatus.STARTED) {
      dispatch(connectionLost());
    }
  });

  messenger.on("xmpp-error", (error) => {
    try {
      const state = getState();
      const status = getStatus(state);

      if (status === AppStatus.CONNECTION_LOST) return;

      if (status === AppStatus.STARTED) {
        dispatch(connectionLost());
      } else {
        dispatch(appFailure());
      }
      log(error);
    } catch (err) {
      log.error(error);
      log(err);
    }
  });

  messenger.on("received-roster", (devices) => {
    dispatch(deviceActions.receivedRoster(devices));
  });

  messenger.on("roster-set", async (device) => {
    debug.messenger("roster-set", device);

    if (device.group === "others") {
      return;
    }

    if (device.name) {
      dispatch(deviceActions.updatePairedDevice(device));
      return;
    }

    try {
      const name = await messenger.getDeviceName(device.jid);

      dispatch(
        deviceActions.updatePairedDevice({
          ...device,
          name,
          familyName: getFamilyName(getState()),
          group: "myDevices"
        })
      );
    } catch (error) {
      log.error("vCard request failed");
    }
  });

  messenger.on("roster-remove", (jid) => {
    debug.messenger("roster-remove");
    dispatch(deviceActions.removePairedDevice(jid));
  });
  messenger.on("received-presence", ({ xmppLogin, status, payload }) => {
    dispatch(
      deviceActions.receivedPresence({
        status,
        jid: xmppLogin,
        avatarId: payload.avatar_id || null
      })
    );
  });

  messenger.on("presence-updated", (presence) => {
    dispatch(presenceUpdated(presence));
  });

  return messenger;
}
